import React from 'react';
import { Button } from '@attain-sre/attain-design-system';
import { CREATE_AUDIENCE } from '../../content';

const CreateAudienceDropdown: any = (props: any) => {
  const { handleMenuItemClick } = props;

  return (
    <Button
      variant='contained'
      color='primary'
      onClick={() => {
        handleMenuItemClick('attain');
      }}
    >
      {CREATE_AUDIENCE}
    </Button>
  );
};

export default CreateAudienceDropdown;
